// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"06ca9ae6","453":"7ced6fb4","541":"09634a78","616":"f254ff71","682":"6df36e0a","691":"dcbbe5a5","706":"6ea6693a","753":"f69056fa","758":"bf2b0c44","804":"1d8295d2","859":"35d731e7","991":"d2a5ee85"}[chunkId] + ".chunk.js";
};